
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: block;
}
:host .content-container-wrapper {
  border-radius: 16px;
  background: #FFFFFF;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
}
:host .content-container-wrapper.shadow {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
}
:host .content-container-wrapper.elevated1 {
  filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
}
:host .content-container-wrapper.elevated2 {
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
:host .content-container-wrapper.field {
  border: 2px solid #E9ECF1;
}
@media (min-width: 768px) {
  :host .content-container-wrapper {
    padding: 80px;
  }
}
@media (min-width: 992px) {
  :host .content-container-wrapper {
    padding: 40px;
  }
}
:host .content-container-wrapper.padding-sm {
  padding: 16px !important;
}
@media (min-width: 768px) {
  :host .content-container-wrapper.padding-sm {
    padding: 40px !important;
  }
}
@media (min-width: 992px) {
  :host .content-container-wrapper.padding-sm {
    padding: 80px !important;
  }
}

:host {
  display: flex;
  flex-direction: column;
}
:host .content-container-wrapper {
  border-radius: 16px;
  padding: 24px;
}
:host .content-container-wrapper.field {
  border-color: var(--slh-color-neutral-shade-20, #EBEEF4);
}

:host([padding=xxs]) .content-container-wrapper {
  padding: 4px;
}

:host([padding=xs]) .content-container-wrapper {
  padding: 8px;
}

:host([padding=sm]) .content-container-wrapper {
  padding: 16px;
}

:host([padding=md]) .content-container-wrapper {
  padding: 24px;
}

:host([padding=lg]) .content-container-wrapper {
  padding: 32px;
}

:host([padding=xl]) .content-container-wrapper {
  padding: 40px;
}

:host([padding=xxl]) .content-container-wrapper {
  padding: 80px;
}

@media (min-width: 560px) {
  :host([padding-sm=xxs]) .content-container-wrapper {
    padding: 4px;
  }
  :host([padding-sm=xs]) .content-container-wrapper {
    padding: 8px;
  }
  :host([padding-sm=sm]) .content-container-wrapper {
    padding: 16px;
  }
  :host([padding-sm=md]) .content-container-wrapper {
    padding: 24px;
  }
  :host([padding-sm=lg]) .content-container-wrapper {
    padding: 32px;
  }
  :host([padding-sm=xl]) .content-container-wrapper {
    padding: 40px;
  }
  :host([padding-sm=xxl]) .content-container-wrapper {
    padding: 80px;
  }
}
@media (min-width: 768px) {
  :host([padding-md=xxs]) .content-container-wrapper {
    padding: 4px;
  }
  :host([padding-md=xs]) .content-container-wrapper {
    padding: 8px;
  }
  :host([padding-md=sm]) .content-container-wrapper {
    padding: 16px;
  }
  :host([padding-md=md]) .content-container-wrapper {
    padding: 24px;
  }
  :host([padding-md=lg]) .content-container-wrapper {
    padding: 32px;
  }
  :host([padding-md=xl]) .content-container-wrapper {
    padding: 40px;
  }
  :host([padding-md=xxl]) .content-container-wrapper {
    padding: 80px;
  }
}
@media (min-width: 992px) {
  :host([padding-lg=xxs]) .content-container-wrapper {
    padding: 4px;
  }
  :host([padding-lg=xs]) .content-container-wrapper {
    padding: 8px;
  }
  :host([padding-lg=sm]) .content-container-wrapper {
    padding: 16px;
  }
  :host([padding-lg=md]) .content-container-wrapper {
    padding: 24px;
  }
  :host([padding-lg=lg]) .content-container-wrapper {
    padding: 32px;
  }
  :host([padding-lg=xl]) .content-container-wrapper {
    padding: 40px;
  }
  :host([padding-lg=xxl]) .content-container-wrapper {
    padding: 80px;
  }
}
@media (min-width: 1200px) {
  :host([padding-xl=xxs]) .content-container-wrapper {
    padding: 4px;
  }
  :host([padding-xl=xs]) .content-container-wrapper {
    padding: 8px;
  }
  :host([padding-xl=sm]) .content-container-wrapper {
    padding: 16px;
  }
  :host([padding-xl=md]) .content-container-wrapper {
    padding: 24px;
  }
  :host([padding-xl=lg]) .content-container-wrapper {
    padding: 32px;
  }
  :host([padding-xl=xl]) .content-container-wrapper {
    padding: 40px;
  }
  :host([padding-xl=xxl]) .content-container-wrapper {
    padding: 80px;
  }
}
@media (min-width: 1400px) {
  :host([padding-xxl=xxs]) .content-container-wrapper {
    padding: 4px;
  }
  :host([padding-xxl=xs]) .content-container-wrapper {
    padding: 8px;
  }
  :host([padding-xxl=sm]) .content-container-wrapper {
    padding: 16px;
  }
  :host([padding-xxl=md]) .content-container-wrapper {
    padding: 24px;
  }
  :host([padding-xxl=lg]) .content-container-wrapper {
    padding: 32px;
  }
  :host([padding-xxl=xl]) .content-container-wrapper {
    padding: 40px;
  }
  :host([padding-xxl=xxl]) .content-container-wrapper {
    padding: 80px;
  }
}
`;
